import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { UserService } from "src/app/core/services/v2/user.service";

@Component({
  selector: "app-casemanager-header-layout",
  templateUrl: "./casemanager-header-layout.component.html",
  styleUrls: ["./casemanager-header-layout.component.scss"],
})
export class CasemanagerHeaderLayoutComponent implements OnInit {
  @Input() photoUrlRecieve: string;
  userName: string;
  greetings: string;
  shortName: string;

  constructor(private router: Router, private userService: UserService,
    private practiceService:PracticeService) {}

  ngOnInit() {
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.userName = userDetails.name;
        const matches = this.userName.match(/\b(\w)/g);
        this.shortName = matches.slice(0, 2).join("");
      },
      (error) => {
        console.error(error);
      }
    );

    const today = new Date();
    const curHr = today.getHours();

    if (curHr < 12) {
      this.greetings = "Good Morning";
    } else if (curHr < 18) {
      this.greetings = "Good Afternoon";
    } else {
      this.greetings = "Good Evening";
    }
  }

  signOut() {
    window.location.href = `/Session/SignOut`;
  }

  stopImpersonating() {
    this.userService.cancelImpersonate();
  }
  isImpersonating()
  {
    if(this.practiceService.getCurrentUser())
    {
      return this.practiceService.getCurrentUser().isImpersonating;
    }

    return false;
  }

 

  
  settingPage() {
    this.router.navigate(["physician/profile/signIn"]);
  }
}
